var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input } from '@angular/core';
import { Cell } from '../../../lib/data-set/cell';
var ViewCellComponent = (function () {
    function ViewCellComponent() {
    }
    return ViewCellComponent;
}());
__decorate([
    Input(),
    __metadata("design:type", Cell)
], ViewCellComponent.prototype, "cell", void 0);
ViewCellComponent = __decorate([
    Component({
        selector: 'table-cell-view-mode',
        template: "\n    <div [ngSwitch]=\"cell.getColumn().type\">\n        <custom-view-component *ngSwitchCase=\"'custom'\" [cell]=\"cell\"></custom-view-component>\n        <div *ngSwitchCase=\"'html'\" [innerHTML]=\"cell.getValue()\"></div>\n        <div *ngSwitchDefault>{{ cell.getValue() }}</div>\n    </div>\n    ",
    })
], ViewCellComponent);
export { ViewCellComponent };
//# sourceMappingURL=view-cell.component.js.map


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/ng2-smart-table/components/cell/cell-view-mode/view-cell.component.js
// module id = ../../../../ng2-smart-table/components/cell/cell-view-mode/view-cell.component.js
// module chunks = 37